import { commitMutation } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';
import { ConnectionHandler } from 'relay-runtime';
import { newEvent, ERROR } from '../../notifications';

const mutation = graphql`
mutation deleteRecordingMutation(
  $input: DeleteRecordingInput!
) {
  deleteRecording(input: $input)
  {
    errors {
      key
      message
      reason
    }
    recording {
      id
      userId
      domainId
    }
  }
}
`;

// FIXME
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
function maybeNotifyError(response) {
  let inError = false;

  if (response && response.deleteRecording.errors !== null) {
    inError = true;
  }
  if (!response) {
    inError = true;
  }

  if (inError) {
    newEvent(ERROR, 'deleteRecordingError', 'deleteRecordingError',
      "Delete recording error");
  }
}

// FIXME
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
function deleteRecording(environment, id, userId, domainId) {
  return new Promise((resolve, reject) => {
    const variables = {
      input: {
        recording: {
          userId,
          domainId,
          id
        }
      },
    };
    commitMutation(
      environment,
      {
        mutation,
        variables,
        updater: (store) => {
          const payload = store.getRootField("deleteRecording");
          // FIXME
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          const model = payload.getLinkedRecord("recording");
          const rec = { id: 'client:root' };
          const parent = store.get(rec.id);
          // FIXME
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          const connection = ConnectionHandler.getConnection(parent, "RecordingList_myRecordings");
          // FIXME
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          ConnectionHandler.deleteNode(connection, model.getValue('id'));
        },
        onCompleted: (response, errors) => {
          if (errors) {
            maybeNotifyError(null);
            return reject(errors);
          }
          maybeNotifyError(response);
          return resolve(response);
        },
        onError: err => {
          maybeNotifyError(null);
          reject(err);
        }
      },
    );
  });
}

export { deleteRecording };
